var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { staticClass: "setting-options", attrs: { label: "选择项" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.radio,
                callback: function($$v) {
                  _vm.radio = $$v
                },
                expression: "radio"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: "静态数据" } }),
              _vm._v(" "),
              _c("el-radio-button", {
                attrs: { label: "远端数据", disabled: "" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "static-data" },
            [
              _vm.value.node.type == "radio" ||
              (_vm.value.node.type == "select" && !_vm.selectMultiple)
                ? _c(
                    "div",
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.defaultValue,
                            callback: function($$v) {
                              _vm.defaultValue = $$v
                            },
                            expression: "defaultValue"
                          }
                        },
                        _vm._l(_vm.options, function(item, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "option-item" },
                            [
                              _c("el-radio", {
                                key: item.label,
                                attrs: { label: item.label }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "option-item_label",
                                attrs: {
                                  placeholder: "请输入内容",
                                  value: item.value
                                },
                                on: {
                                  input: function(value) {
                                    return _vm.editOptionValue(item, value)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                staticClass: "option-item_value",
                                attrs: { placeholder: "请输入内容" },
                                model: {
                                  value: item.label,
                                  callback: function($$v) {
                                    _vm.$set(item, "label", $$v)
                                  },
                                  expression: "item.label"
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "option-delete_button el-icon-minus",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteOption(i)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.value.node.type == "checkbox" ||
              (_vm.value.node.type == "select" && _vm.selectMultiple)
                ? _c(
                    "div",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.defaultValue,
                            callback: function($$v) {
                              _vm.defaultValue = $$v
                            },
                            expression: "defaultValue"
                          }
                        },
                        _vm._l(_vm.options, function(item, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "option-item" },
                            [
                              _c("el-checkbox", {
                                key: item.label,
                                attrs: { label: item.label }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "option-item_label",
                                attrs: {
                                  placeholder: "请输入内容",
                                  value: item.value
                                },
                                on: {
                                  input: function(value) {
                                    return _vm.editOptionValue(item, value)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ],
                                staticClass: "option-item_value",
                                attrs: { placeholder: "请输入内容" },
                                model: {
                                  value: item.label,
                                  callback: function($$v) {
                                    _vm.$set(item, "label", $$v)
                                  },
                                  expression: "item.label"
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "option-delete_button el-icon-minus",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteOption(i)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "option-add_button",
                  attrs: { type: "text" },
                  on: { click: _vm.addOption }
                },
                [_vm._v("添加选项")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "remote-data" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85d41c48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85d41c48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingOptions.vue
// module id = null
// module chunks = 